@if (!node.children) {
  @if (node.isOldSetup) {
    <a id='{{node.id}}' (click)="navigateToOldSetup(node.link, $event.ctrlKey)" (mousedown)="handleMousedown(node, $event)" [innerHTML]="node.label"
    [ngClass]="{'menu-active':node.active}"></a>
  }
  @if (!node.isOldSetup) {
    <a id='{{node.id}}' routerLink={{node.link}} [innerHTML]="node.label" [ngClass]="{'menu-active':node.active}"></a>
  }
} @else {
  <a id='{{node.id}}' (click)="node.isCollapsed = !node.isCollapsed" [ngClass]="{'rotate': !node.isCollapsed}" innerHTML='{{node.label}} <i class="sap-icon">&#xe1e2;</i>'
  [ngClass]="{'menu-active':node.active}">
</a>
}


